<template>
  <div>
    <!--<van-nav-bar title="尿素自助加注" left-text="返回" left-arrow @click-left="onClickLeft"/>-->
    <van-notice-bar wrapable :scrollable="false" text="系统将按实际加注量自动扣款，加注升数将限制最大加注量，启动加注后请在60s内提枪加注"/>
    <div style="margin: 10vw;">
    </div>
    <van-form @submit="onSubmit">
      <van-field label="" value="尿素自助加注机" readonly/>
      <van-field v-model="device_imei" label="设备号" readonly/>
      <van-field v-model="mobile" label="手机号" readonly/>
      <van-field v-model="truckNo" label="车牌" readonly/>
      <van-field label="加注升数" placeholder="请输入加注升数" readonly clickable :value="value" @touchstart.native.stop="show = true"/>
      <van-number-keyboard theme="custom" extra-key="." close-button-text="完成" v-model="value" :show="show" :maxlength="6" @blur="show = false"/>
      <div style="margin: 10vw;">
        <van-button round block size="large" type="info" native-type="submit">启动加注机</van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
import Vue from 'vue';
import {Dialog, Form, NoticeBar, NumberKeyboard} from 'vant';
import common from "../../common";

Vue.use(Form);
Vue.use(NoticeBar);
Vue.use(NumberKeyboard);

export default {
  name: "qrcode",
  data() {
    return {
      device_imei: "",
      qrcode: '',
      show: true,
      value: '',
      token: "",
      mobile: "",
      data: "",
      pre_price: "",
      pre_num: "",
      truckNo: "",
      userId: "",
      userName: "",
      service: "",
      requestId: "",
      ureaNumber: "",
    }
  },
  methods: {
    onClickLeft() {

    },
    onSubmit(values) {
      let querystring = require("querystring");
      this.$api.post("wx/urea/order",
          querystring.stringify({
            value: this.value,
            device_imei: this.device_imei,
            mobile: this.mobile,
            service: this.service,
            pre_price: this.pre_price,
            userId: this.userId,
            userName: this.userName,
            truckNo: this.truckNo,
            ureaNumber: this.ureaNumber,
          })
      ).then(({data}) => {
        if (data.status == 1) {
          Dialog.alert({
            message: data.msg,
          }).then(() => {
            this.$router.push({path: "wx/urea/order"});
          });
        } else {
          Dialog.alert({
            message: data.msg,
          }).then(() => {

          });
        }
      });
    },
  },
  mounted() {
    this.device_imei = this.$router.currentRoute.params.imei;
    this.qrcode = this.$route.query.qrcode;
    this.value = this.$route.query.pre_num;
    this.pre_price = this.$route.query.pre_price;
    //判断cookie中是否存在token
    let ifcookietoken = document.cookie.indexOf("token=") != -1;
    //判断地址栏上是否存在openid;
    let ifopenid = window.location.href.indexOf("openid") != -1;
    //判断是否已经登录
    if (!!JSON.parse(common.getlocalStorage("userInfo"))) {
      this.mobile = JSON.parse(common.getlocalStorage("userInfo")).mobile;
      this.login_bol = true;
      let token = JSON.parse(common.getlocalStorage("userInfo")).token;
    } else {
      // this.$router.replace({
      //   name: "login"
      // });
    }
    if (this.qrcode) {
      let querystring = require("querystring");
      this.service = 'yzs';
      this.$api.post("wx/urea/qrcode",
          querystring.stringify({
            qrcode: this.qrcode,
            stationId: '202',
          })
      ).then(data => {
        if (data.data.status == 1) {
          data = data.data.data.data;
          this.mobile = data.userPhone;
          this.truckNo = data.truckNo;
          this.userId = data.userId;
          this.userName = data.userName;
          this.ureaNumber = data.ureaNumber;
          this.requestId = data.requestId;
        } else {
          common.toast(data.data.msg);
        }
      });
    }else{
      common.toast("尿素自助加注异常，请联系客服！");
      this.$router.replace({
        name: "Home"
      });
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/urea/qrcode.vue